import http from '@/utils/http-interceptor';
import Vue from 'vue';

export default {
  name: 'Login',
  data() {
    return {
      telNumber: '',
      passwd: '',
      toastTel: '',
      toastPswd: '',
      isDisabled: false
      // toastShow: false,
      // toastText: ''
    }
  },
  mounted: function () {
    this.banScale();
    var data = localStorage.getItem('userPhone');
    if (data)
      this.telNumber = data.trim()
  },
  methods: {
    // toast (str) {
    //   let v = this
    //   v.toastText = str
    //   v.toastShow = true
    //   setTimeout(function(){
    //     v.toastShow = false
    //   }, 1500)
    // },
    banScale(){
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })//禁止缩放
    },
    doSubmit() {
      if (this.isDisabled)
        return;
      var self_lis = this;
      this.telNumber=this.telNumber.trim();
      this.passwd=this.passwd.trim();
      var pattern = new RegExp(/^\d{11}$/)
      var params = {
        userPhone: this.telNumber,
        password: this.passwd
      }
      if (!this.telNumber || !this.passwd || !pattern.test(this.telNumber)) {
        if (!this.telNumber) this.toastTel = '请输入您的手机号'
        if (!this.passwd) this.toastPswd = '请输入密码'
        if (!pattern.test(this.telNumber))
          this.toastTel = '请输入11位手机号'
      } else {
        this.isDisabled = true;
        http.get('/circle/v1/operating/login', {
          params: params
        })
          .then(function (response) {
            if (response.data.status == 1) {
              sessionStorage.setItem('userId', response.data.data.id)
              sessionStorage.setItem('userName', response.data.data.userName)
              sessionStorage.setItem('userPhone', response.data.data.userPhone)
              localStorage.setItem('userPhone', response.data.data.userPhone)
              this.$router.push({name: 'Manage'})
            } else {
              this.toastPswd = response.data.msg;
            }
            this.isDisabled = false;
          })
          .catch(function (response) {
            alert('error')
            this.isDisabled = false;
            console.log('err' + response)
          })
      }
    },
    //ios 12+ 微信中白板bug
    checkWxScroll(){
      var ua = navigator.userAgent.toLowerCase();
      var u = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if(ua.match(/MicroMessenger/i) == 'micromessenger'&&!!u){
        var osVersion  =  navigator.userAgent.match(/iPhone\sOS\s([\d\_]+)/i);
        var  osArr = osVersion.length>=1? osVersion[1].split('_'):[];
        var newOS = osArr.length>=2 && (osArr[0]>11)
        if(newOS){
          this.temporaryRepair();
        }
      }
    },
    temporaryRepair(){
      var currentPosition,timer;
      var speed=1;
      timer=setInterval(function(){
        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
        currentPosition-=speed;
        window.scrollTo(0,0);
        clearInterval(timer);
      },1);
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/page/scene/login/lg.js